
import {
  faAddressBook,
  faArrowLeft,
  faBars,
  faBolt,
  faCalculator,
  faClipboardQuestion,
  faFileInvoiceDollar,
  faFolderOpen,
  faHome,
  faMapLocationDot,
  faReceipt,
  faSignature,
  faUser,
  IconDefinition,
} from "@fortawesome/free-solid-svg-icons";
import { QuestionnaireItem } from "../../../../interfaces/dynamicForms/Forms";
import { evaluateCondition } from "../RuleEngine";

export type SelectOption = { value: string; label: string };

export function isQuestionVisible(
  q: QuestionnaireItem,
  data: Record<string, any>
): boolean {
  if (q.showIf) {
    for (const cond of q.showIf) {
      if (!evaluateCondition(cond, data)) return false;
    }
  }
  if (q.hideIf) {
    for (const cond of q.hideIf) {
      if (evaluateCondition(cond, data)) return false;
    }
  }
  return true;
}

/** Convert any string[] to {value,label}[], or leave it alone if it’s already object[] */
export function normalizeOptions(
  input: Array<string | SelectOption> | undefined
): SelectOption[] {
  if (!Array.isArray(input) || input.length === 0) {
    return [];
  }

  if (typeof input[0] === "string") {
    return (input as string[]).map((str) => ({
      value: str,
      label: str,
    }));
  }

  // Already formatted correctly
  return input as SelectOption[];
}

export const getIcon = (icon: string): IconDefinition => {
  switch (icon) {
    case "faUser":
      return faUser;
    case "faMapLocationDot":
      return faMapLocationDot;
    case "faAddressBook":
      return faAddressBook;
    case "faBolt":
      return faBolt;
    case "faFolderOpen":
      return faFolderOpen;
    case "faClipboardQuestion":
      return faClipboardQuestion;
    case "faSignature":
      return faSignature;
    case "faFileInvoiceDollar":
      return faFileInvoiceDollar;
    case "faHome":
      return faHome;
    case "faReceipt":
      return faReceipt;
    case "faCalculator":
      return faCalculator;
    default:
      return faBars; // Default icon if no match is found
  }
};
